
import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import PageTitle from '../../layouts/PageTitle';
import Details from './details.component';
import '../../../scss/pages/_order-list.scss'
import useFoodhubApi from '../../../Hooks/useFoodhubApi';

import {
    getAllOrderAction,
    getSelectedOrderAction
} from '../../../store/actions/OrderActions';
import { useDispatch, useSelector } from 'react-redux';




const OrderList = ({ onNote }) => {


    const dispatch = useDispatch();

    const [modalCentered, setModalCentered] = useState(false);

    const [details, setDetails] = useState(false);


    const { baseURL } = useFoodhubApi();

    //const user = JSON.parse(localStorage.getItem('userDetails'));


    const allOrders = useSelector((state) => state.allOrders?.allorders);
    const order = useSelector((state) => state.allOrders?.order);


    function fetchOrder(id) {
        dispatch(getSelectedOrderAction(id));
    }

    function fetchAllOrders() {
        dispatch(getAllOrderAction());
    }

    useEffect(() => {
        fetchAllOrders();
    }, []);

    // useEffect(() => {
    //     fetchOrder();
    // }, []);


    // useEffect(() => {
    //     fetch(`${baseURL}admin/orders?type=all`, {
    //         headers: {
    //             "x-access-token": `${user?.accessToken}`
    //         }
    //     })
    //         .then(res => res.json())
    //         .then(data => setOrders(data?.payload))
    // }, [!orders])



    const handleClose = () => setModalCentered(false)

    const handleDetailsSidebar = (action, id) => {
      
        if (action === "open") {
            setDetails(true)
            fetchOrder(id);
        }
        else {
            setDetails(false)
        }
    }

    return (
        <div className='OrderList'>
            <PageTitle
                title="Orders"
                subtitle="See live orders your restaurants are receiving"
            />
            <div className='row w-100'>
                <div className='d-flex justify-content-between mt-3'>
                    <div>
                        <span>
                            <div className="form-check form-switch d-flex align-items-center">
                                <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault" style={{ width: "3em" }} />
                                <label className="form-check-label ps-2" htmlFor="flexSwitchCheckDefault">Cancelled Only</label>
                            </div>
                        </span>
                    </div>
                    <div className='d-flex justify-content-end'>
                        <div className='listMoadal' style={{ paddingRight: '50px' }}>
                            <span onClick={() => setModalCentered(true)}>  <i className="mdi mdi-send" style={{ fontSize: '20px', color: 'grey' }}></i></span>
                            <Modal className="fade" centered onHide={handleClose} show={modalCentered}>
                                <Modal.Body>
                                    <h5>Order Export</h5>
                                    <p>
                                        Email all orders of all restaurants as .csv file. The CSV might have too many orders. If it does not arrive,please select a shorter timefram.
                                    </p>
                                    <input type="email" name="email" className='form-control' id="email" placeholder="Email Address Here" />
                                </Modal.Body>
                                <div className='d-flex justify-content-between p-4'>
                                    <select className='border-0' name="week" id="week">
                                        <option value="">Today</option>
                                        <option value="">Yesterday</option>
                                        <option value="" selected>This week</option>
                                        <option value="">Last week</option>
                                        <option value="">Custom</option>
                                    </select>
                                    <Button variant="primary">Send</Button>
                                </div>
                            </Modal>
                        </div>
                        <div style={{ paddingRight: '50px' }}>
                            <span>28s</span>
                            <i className="mdi mdi-restore ms-3" style={{ color: 'grey' }}></i>
                        </div>
                        <div style={{ paddingRight: '50px' }}>
                            <i className="mdi mdi-magnify" style={{ color: 'grey' }}></i>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-body">
                <div className="w-100">
                    <table id="example" className="table display w-100 orderTable">
                        <thead>
                            <th>Order ID</th>
                            <th> Restaurant </th>
                            <th> Status </th>
                            <th> Order placed at </th>
                        </thead>
                        <tbody className='orderTablebody'>


                            {
                                allOrders?.payload?.map(item =>
                                    <tr onClick={() => handleDetailsSidebar("open", item?.id)}>
                                        <td>{item?.order_number}</td>
                                        <td>{item?.branch?.name}</td>
                                        <td>  <i
                                            className={`fa fa-circle 
                                            ${item?.order_status === "pending" && "text-warning"}
                                            ${item?.order_status === "preparing" && "text-info"}
                                            ${item?.order_status === "delivered" && "text-success"}
                                            ${item?.order_status === "rejected" && "text-danger"}`}
                                        > </i> {item?.order_status}</td>
                                        <td>{item?.order_datetime}</td>
                                    </tr>
                                )
                            }

                        </tbody>
                    </table>
                    <Details handleDetailsSidebar={handleDetailsSidebar} details={details} order={order?.payload} />
                </div>
            </div>
        </div>
    );
};

export default OrderList; 